import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Component, DestroyRef, ViewChild, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ToastAlertService } from '@core/services';
import { WorkerGroupModalComponent } from '../../../components/modals/groups/worker-group-modal/worker-group-modal.component';
import { WorkerGroup } from '../../../models/worker-group.model';
import {
  BusinessService,
  ConfigService,
  UserGroupService,
  UserService,
} from '../../../services';
import { ModalAlertComponent } from '@shared/components';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { ButtonComponent } from '@shared/components/button/button.component';
import { SearchFieldComponent } from '@shared/components/search-field/search-field.component';
import { ToolbarComponent } from '@shared/components/toolbar/toolbar.component';
import { Cookies } from 'typescript-cookie';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';

@Component({
  templateUrl: './worker-group-page.component.html',
  standalone: true,
  imports: [
    ToolbarComponent,
    SearchFieldComponent,
    ButtonComponent,
    MatCardModule,
    MatTableModule,
    MatSortModule,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatSelectModule,
  ],
})
export class WorkerGroupPageComponent {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  private dialog = inject(MatDialog);
  private workerGroupService = inject(UserGroupService);
  private alertService = inject(ToastAlertService);
  public icon = 'add';
  private destroyRef = inject(DestroyRef);
  fielInput!: string;
  dataSource: MatTableDataSource<WorkerGroup>;
  displayedColumns: string[] = ['name', 'description', 'options'];

  //DATA
  public isSysAdmin = inject(ConfigService).isSysAdmin;
  private userService = inject(UserService);
  private businessService = inject(BusinessService);

  private businessId: number | null | undefined;
  public selectedBussines = -1;
  public bussines: any[] = [];

  constructor() {
    this.dataSource = new MatTableDataSource();
  }
  ngOnInit(): void {
    this.loadworkers();
  }
  loadworkers() {
    this.dataSource = new MatTableDataSource();
    const business = Cookies.get('bussinesId');
    if (business != null) {
      this.businessId = parseInt(business.toString());
      this.selectedBussines = this.businessId;
    } else {
      if (this.selectedBussines === -1) {
        this.businessId = null;
      }
    }

    this.getBusiness();
    this.chargueData();
  }
  private getBusiness() {
    this.businessService
      .getBusiness()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (request: any) => {
          if (request.code === 10000) {
            this.bussines = request.reply;
          }
        },
      });
  }
  ValidBusiness_id(): boolean {
    return this.businessId === null;
  }

  modalAction(action?: WorkerGroup) {
    if (this.selectedBussines === -1) {
      this.alertService.error('Por favor selecciona una empresa.');
    } else {
      let width: string;
      if (window.innerWidth <= 768) {
        width = '90%';
      } else {
        width = '50%';
      }
      const dialogActionDetail = this.dialog.open(WorkerGroupModalComponent, {
        width: width,
        data: {
          action: action,
          businessId: this.selectedBussines,
        },
        disableClose: true,
      });
      dialogActionDetail
        .beforeClosed()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(result => {
          if (result) {
            this.loadworkers();
          }
        });
    }
  }

  modalDelete(action: WorkerGroup) {
    const dialogDelete = this.dialog.open(ModalAlertComponent, {
      data: action?.name,
      disableClose: true,
    });
    dialogDelete
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((result: boolean) => {
        if (!result) return;
        this.workerGroupService
          .deleteUserGroup(action.id)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe({
            next: resp => {
              if (resp.code === 10000 || resp.code === 40009) {
                this.alertService.sucess('Grupos de usuarios eliminado');
                this.loadworkers();
              }
            },
          });
      });
  }
  chargueData() {
    this.workerGroupService
      .getUserGroups(this.selectedBussines)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: resp => {
          if (resp.code === 10000) {
            this.dataSource = new MatTableDataSource(resp.reply);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
          }
        },
      });
  }
}
